import { format, isValid, parseISO } from "date-fns";

import { formatRelativeShort } from "src/utils/time";

export const parseTimestamp = (timestamp: string | null | undefined) => {
  if (!timestamp) return null;
  const date = parseISO(timestamp);
  return isValid(date) ? date : null;
};

export const formatAbsolute = (date: Date) =>
  format(date, "MMM d, yyyy 'at' h:mm a");

/** "3h ago (Aug 24, 2026 at 12:51 PM)" mid-sentence, or "on Aug 24, 2026 at 12:51 PM" once the relative part falls back to a date. */
export const formatSubmittedWhen = (timestamp: string | null | undefined) => {
  const date = parseTimestamp(timestamp);
  if (!timestamp || !date) return null;
  const relative = formatRelativeShort(timestamp);
  const absolute = formatAbsolute(date);
  if (relative === "Just now") return `just now (${absolute})`;
  return relative.endsWith(" ago")
    ? `${relative} (${absolute})`
    : `on ${absolute}`;
};

// Meta's reasons arrive with or without a final period, and the next step follows as its own sentence.
export const asSentence = (text: string) =>
  /[.!?]$/.test(text) ? text : `${text}.`;
